import { ContextMenu, showActionsPage } from 'Components'
import { useState, useEffect }  from 'react'
import { connect } from 'react-redux'
import { expandNodes } from 'Services/GraphUtils'
import { createRelationInGraph, removeVisPrefix } from '../GraphView/Utils'
import { enc, getNamespaceLabel } from 'Services/WeaverUtils'
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom'
import { useQuery } from 'Hooks'
import SizeService from 'Services/SizeService'
import ColorService from 'Services/ColorService'
import { MergeRequest } from 'Model'
import jsonPath from 'jsonpath'

import {
  setCreatingNode,
  setCurrentItem,
  setEditingNode,
  setTab,
  setTabDisabled,
} from 'Actions/explore'

import {
  removeGraphEdge,
  removeGraphEdges,
  removeGraphNode,
  removeGraphNodes,
  updateGraphNodes,
  updateGraphGroups,
} from 'Actions/graph'

import { setGraphRenameRelationProps, setGraphCreatingEdge, setGraphAddingEdge, setGraphColorPickerProps, setQueryResults } from "../Context/actions"
import { useGraphData } from '../Context'

import {
  setFilteredNodesByOther,
  updateTypeFilter,
  updateTypeFilters
} from 'Actions/graphFilter'

import {
  getMemberKey,
  getMemberKeys,
  getNodeLabel,
  getProjectData,
  splitUid,
  getUid,
  WeaverQuery
} from 'Services/WeaverUtils'
import { message, Modal } from 'antd'
import {
  NODE,
  RELATION,
  VIEWTYPE,
  ATTRIBUTES,
  QUERY
} from 'Types'

const GraphContextMenu = ({ currentItem, data, children, macros, nodeView, ...props }) => {

  const { graphData, active, setActive } = data
  const [graphCtx, dispatch] = useGraphData()
  const { visToWvrMap } = graphCtx

  const [activeNode, setActiveNode] = useState(undefined)
  const [activeSelection, setActiveSelection] = useState(undefined)
  const [isPublic, setIsPublic] = useState(false)
  const params = useQuery()
  const history = useHistory()
  const { url } = useRouteMatch()
  const { hash }  = useLocation()

  const getNodeAndType = (id) => graphData.nodes[id]

  const getRelation = (id) => graphData.nodes[id] || graphData.edges[id]

  const collectRecords = (objectJson) => {
    const list = [];
    if (objectJson.attributes) {
      for (const key in objectJson.attributes) {
        objectJson.attributes[key].forEach((record) => list.push(record));
      }
    }
    if (objectJson.relations) {
      for (const key in objectJson.relations) {
        objectJson.relations[key].forEach((record) => list.push(record));
      }
    }
    if (objectJson.relationsIn) {
      for (const key in objectJson.relationsIn) {
        objectJson.relationsIn[key].forEach((record) => list.push(record));
      }
    }
    return list;
  }

  useEffect(() => {
    (async () => {
      if (active?.type === NODE) {
        if ( _.size(active.nodes) === 1) {
          setActiveNode(getNodeAndType(active.nodes[0]))
          setActiveSelection(undefined)
        } else {
          setActiveSelection(_.map(active.nodes, getNodeAndType))
          setActiveNode(undefined)
        }
      } else if (active?.type === RELATION) {
        if (_.size(active.edges) === 1) {
          setActiveNode(getRelation(active.edges[0]))
          setActiveSelection(undefined)
        } else if (_.size(active.nodes) === 1) {
          setActiveNode(getRelation(active.nodes[0]))
          setActiveSelection(undefined)
        } else {
          setActiveSelection(_.map(active.edges, getRelation))
          setActiveNode(undefined)
        }
      } else {
        setActiveSelection(undefined)
        setActiveNode(undefined)
      }
    })()
  }, [active])

  useEffect(() => {
    (async () => {
      const currProj = await Weaver.Project.load(props.currentProject)
      const acl = await currProj.getACL()
      const spaceIsPublic = await acl.getPublicReadAccess()
      setIsPublic(spaceIsPublic)
    })()
  }, [])

  const macroEditMenuItem = {
    key: 'edit-sequence',
    title: 'Edit via form',
    requiresWriteAccess: true,
    hidden: () => !((activeNode?.id && macros.length > 0) && !activeNode?.from)
  }

  const macroList = macros.map((m) => m.get('configBlob'))

  const createMacroSubMenu = (macroList) => {
    const items = _.map(macroList, (macro) => (
      {
        key: _.kebabCase(macro.title),
        title: macro.title,
        onClick: () => {
          const nodeId = activeNode.wvrId || activeNode.id
          showActionsPage({
            ...macro,
            nodeId,
            mode: 'edit',
            title: <span>Edit <b>{nodeId}</b></span>
          })
        }
      }
    ))

    if (items.length === 1) {
      macroEditMenuItem.onClick = items[0].onClick
    } else {
      macroEditMenuItem.submenu = items
    }
  }

  let typeIds = []
  if (activeNode?.type) {
    typeIds = activeNode.type.map((t) => t?.id) || []
  }

  const typedMacros = macroList.filter((m) => typeIds.includes(_.get(m, 'formSequence.onSave.node.typeNode')))
  const untypedMacros = macroList.filter((m) => !_.get(m, 'formSequence.onSave.node.typeNode'))
  createMacroSubMenu([...untypedMacros, ...typedMacros])

  let projectSpecificActions;
  if (getProjectData().getProjectSpecificActions) {
    projectSpecificActions = getProjectData().getProjectSpecificActions({ activeNode, currentItem, data, ...props })
  }

  const actions = [ ...projectSpecificActions || [], {
    key: 'open',
    title: 'Open',
    submenu: [{
      key: 'open-in-graph',
      title: () => activeNode ? <span>Open <b>{activeNode?.label}</b> in graph view</span> : <span>Open <b>{_.size(activeSelection)} nodes</b> in graph view</span>,
      onClick: () => {
        if (activeNode?.sources) {
          props.setCurrentItem({
            type: QUERY,
            data: {
              query: new Weaver.Query()
                .restrict(activeNode.sources)
            }
          })
        } else if (activeNode && activeNode.wvrId) {
          props.setCurrentItem({
            id: activeNode.wvrId,
            type: NODE
          })
        } else {
          props.setCurrentItem({
            type: QUERY,
            data: {
              query: new Weaver.Query()
                .restrict(_.map(activeSelection, 'wvrId'))
            }
          })
        }
      },
      hidden: active?.type !== NODE
    }, {
      key: 'type-view-of-this-node',
      title: () => <span>Open type view for type <b>{getNamespaceLabel(activeNode?.type[0]?.label)}</b></span>,
      onClick: () => {
        props.setCurrentItem({
          id: activeNode?.type[0]?.id,
          type: NODE,
          viewType: VIEWTYPE.ABSTRACT
        })
      },
      hidden: () => active?.type !== NODE || !activeNode?.type[0]?.id || activeSelection
    }, {
      key: 'open-identifier-as-graph',
      title: () => <span>Open identifier as graph</span>,
      onClick: () => {
        const [id, graph] = splitUid(activeNode.wvrId)
        let restrictBuffer = []
        let filterFunction = (objectJson, q) => {
          if (q !== undefined && restrictBuffer.length === 0) {
            q._restrict.forEach((n) => { restrictBuffer.push(n.id) })     // This is the original set of ?node bindings from sparql
          }
          return (restrictBuffer.indexOf(objectJson.nodeId) > -1);
        }
        props.setCurrentItem({
          type: QUERY,
          data: {
            query: new Weaver.Sparql(`
              SELECT ?node WHERE {
                {
                  GRAPH <${id}> { ?node ?p ?o }
                } UNION {
                  GRAPH <${id}> { ?s ?p ?node }
                } UNION {
                  GRAPH <${id}> { ?node ?s ?p ?o }
                } UNION {
                  GRAPH <${id}> { ?m ?s ?p ?o }
                  ?node ?rel ?m
                } UNION {
                  GRAPH <${id}> { ?m ?s ?p ?o }
                  ?m ?rel ?node
                }
              }
            `).findNodesQuery(
              new Weaver.Query()
              .setMetaNodesQuery(
                new Weaver.Query()
                .selectIn('*')
                .selectOut('*')
                .setFilterFunction(filterFunction)
              ).setFilterFunction(filterFunction))
          }
        })
      },
      hidden: () => active?.type !== NODE
    }
  ],
  }, {
    key: 'hide',
    title: 'Hide',
    submenu: [{
      key: 'hide-node',
      title: () => activeNode ? <span>Hide <b>{activeNode?.label}</b> from graph</span> : <span>Hide <b>{_.size(activeSelection)} nodes</b> from graph</span>,
      onClick: () => {
        if (activeNode) {
          props.removeGraphNode(activeNode.id)
        } else {
          props.removeGraphNodes(_.map(activeSelection, 'id'))
        }
      },
      hidden: active?.type !== NODE
    }, {
      key: 'all-of-this-type',
      title: <span>Hide all nodes for type <b>{ activeNode && activeNode?.type?.label}</b></span>,
      onClick: () =>
        props.updateTypeFilter({
          id: activeNode.type.id,
          label: activeNode?.type?.label,
          enabled: false
        }),
      hidden: () => active?.type !== NODE || !activeNode?.type || activeSelection
    }, {
      key: 'all-unrelated',
      title: () => <span>Hide all unrelated nodes to <b>{activeNode?.label}</b></span>,
      onClick: () => {
        const { nodes, edges } = graphData
        nodesToShow = _.filter(edges, (edge) =>
          edge.from === activeNode.wvrId || activeNode.id || edge.to === activeNode.wvrId || activeNode.id
        ).reduce((acc, edge) => {
          const source = edge.from
          const target = edge.to

          if (!acc.includes(source)) {
            acc.push(source)
          }
          if (!acc.includes(target))
            acc.push(target)
          acc
        }, [])

        nodesToShow.push(activeNode.wvrId || activeNode.id)

        const nodesToHide = Object.keys(nodes).filter((node) =>
          !nodesToShow.includes(node)
        )

        props.setFilteredNodesByOther(nodesToHide)
      },
      hidden: active?.type !== NODE || activeSelection
    }, {
      key: 'hide-other-types',
      title: () => <span>Hide all types except <b>{activeNode?.type?.label}</b></span>,
      onClick: async () => {
        const [id, graph] = splitUid(activeNode.type.id)
        const typesToHide = await new WeaverQuery()
          .hasNoRecursiveRelationOut(getMemberKey(), Weaver.Node.getFromGraph(id, graph), true)
          .hasRelationIn(getMemberKeys())
          .find()

        props.updateTypeFilters(
          _.keyBy(_.map(typesToHide, (type) => (
            {
              id: getUid(type),
              label: getNodeLabel(type),
              enabled: false
            })
          ), 'id')
        )
      },
      hidden: () => active?.type !== NODE || !activeNode?.type
    }]
  }, {
    key: 'create-node',
    title: 'Create node',
    requiresWriteAccess: true,
    onClick: () => props.setCreatingNode(true),
    hidden: active || graphData.abstract,
  }, {
    key: 'edit-node',
    title: () => <span>Edit <b>{activeNode?.label}</b></span>,
    requiresWriteAccess: true,
    onClick: async () => {
      const [id, graph] = splitUid(activeNode.wvrId || activeNode.id)
      props.setEditingNode(await new Weaver.Query().restrict(Weaver.Node.getFromGraph(id, graph)).selectIn('*').withRelations().first())
    },
    hidden: (active?.type !== NODE) || graphData.abstract || activeSelection
  }, {
    ...macroEditMenuItem
  }, {
    key: 'edit-color',
    title: 'Edit color',
    requiresWriteAccess: true,
    submenu: [{
      key: 'edit-color-for-type',
      title: () => <span>Edit color for type <b>{activeNode?.type?.label}</b></span>,
      onClick: () => {
        dispatch(setGraphColorPickerProps({
          target: activeNode.type[0].id,
          event: active.event,
          getColor: (target) => ColorService.getColorForType(target),
          onSave: (uid, color) => {
            ColorService.setColorForType(uid, color)
            props.updateGraphGroups({
              groups: {
                [uid]: {
                  ...graphData.groups[uid],
                  color
                }
              }
            })
          }
        }))
      },
      hidden: () => !activeNode?.type
    }, {
      key: 'edit-color-for-graph',
      title: () => <span>Edit color for graph <b>{activeNode?.graph}</b></span>,
      onClick: () =>
        dispatch(setGraphColorPickerProps({
          target: activeNode.graph,
          event: active.event,
          getColor: (target) => ColorService.getColorForGraph(target),
          onSave: (graph, color) => {
            ColorService.setColorForGraph(graph, color)
            props.updateGraphGroups({
              groups: {
                [graph]: {
                  ...graphData.groups[graph],
                  color
                }
              }
            })
          }
        })),
      hidden: () => !activeNode?.graph
    }],
    hidden: () => !activeNode?.type && !activeNode?.graph
  }, {
    key: 'set-size',
    title: () => <span>Set size for type <b>{activeNode?.type?.label}</b></span>,
    submenu: [
      ['xs', 'Extra small'],
      ['sm', 'Small'],
      ['md', 'Medium'],
      ['lg', 'Large'],
      ['xl', 'Extra large']
    ].map(([size, label]) => ({
        key: `set-size-${ size }`,
        title: label,
        onClick: () => {
          const id = activeNode.type.id
          const size = SizeService.setSizeForType(id, size)
          if (!graphData.abstract) {
            props.updateGraphNodes({
              groups: {
                [id]: {
                  ...graphData.groups[id],
                  size
                }
              }
            })
          }
        }
      })
    ),
    hidden: () => currentItem?.viewType === VIEWTYPE.ABSTRACT || !activeNode?.type
  }, {
    key: 'create-relation',
    requiresWriteAccess: true,
    title: 'Create relation',
    onClick: () => {
      dispatch(setGraphCreatingEdge(undefined))
      dispatch(setGraphAddingEdge(true))
    },
    hidden: (active || _.isEmpty(graphData.nodes)) || graphData.abstract
  }, {
    key: 'create-relation-from',
    requiresWriteAccess: true,
    title: () => {
      if (activeNode) {
        return <span>Create relation from <b>{activeNode?.label}</b></span>
      } else if (activeSelection) {
        return <span>Create relation from <b>{_.size(activeSelection)} nodes</b></span>
      }
    },
    onClick: async () => {
      const activeSources = activeNode ? [activeNode] : activeSelection
      const sourceIds = _.map(activeSources, 'wvrId')

      dispatch(setGraphAddingEdge(false))

      const promise = new Promise((resolve, reject) => {
        dispatch(setGraphCreatingEdge({
          x: active.event.layerX,
          y: active.event.layerY,
          edgeData: {
            from: sourceIds.length === 1 ? sourceIds[0] : sourceIds
          },
          promise: {
            resolve,
            reject
          }
        }))
      })
      const { sources, relKeys, targets } = await promise
      const results = await createRelationInGraph(relKeys, sources, targets)
      dispatch(setQueryResults(results))
      dispatch(setGraphCreatingEdge(undefined))
    },
    hidden: active?.type !== NODE || graphData.abstract
  }, {
    key: 'create-relation-to',
    requiresWriteAccess: true,
    title: () => {
      if (activeNode) {
        return <span>Create relation to <b>{activeNode?.label}</b></span>
      } else if (activeSelection) {
        return <span>Create relation to <b>{_.size(activeSelection)} nodes</b></span>
      }
    },
    onClick: async () => {
      const activeTargets = activeNode ? [activeNode] : activeSelection
      const targetIds = _.map(activeTargets, 'wvrId')

      dispatch(setGraphAddingEdge(false))
      const promise = new Promise((resolve, reject) =>
        dispatch(setGraphCreatingEdge({
          edgeData: {
            to: targetIds.length === 1 ? targetIds[0] : targetIds
          },
          x: active.event.layerX,
          y: active.event.layerY,
          promise: {
            resolve,
            reject
          }
        }))
      )

      const { sources, relKeys, targets } = await promise
      const results = await createRelationInGraph(relKeys, sources, targets)
      dispatch(setQueryResults(results))
      dispatch(setGraphCreatingEdge(undefined))
    },
    hidden: active?.type !== NODE || graphData.abstract
  }, {
    key: 'copy-url',
    title: () => <span>Copy shareable link for <b>{activeNode?.label}</b></span>,
    onClick: async () => {
      await navigator.clipboard.writeText(`${location.origin}/${props.currentProject}#${activeNode.wvrId || activeNode.id}`)
      message.success('Copied to clipboard')
    },
    hidden: () => (active?.type !== NODE) || activeSelection
  },{
    key: 'add-remove-relation-attributes',
    title: () => <span>Add/Remove attributes on <b>{ activeNode?.key }</b></span>,
    requiresWriteAccess: true,
    onClick: async () => {
      const [id, graph] = splitUid(activeNode.wvrId || activeNode.id)
      props.setEditingNode(await new Weaver.Query().restrict(Weaver.Node.getFromGraph(id, graph)).withRelations().first())
    },
    hidden: () => (active?.type !== RELATION) || (activeNode?.id.includes('->')) || (graphData.abstract) || (activeSelection)
  }, {
    key: 'rename-relation',
    title: () => <span>Rename relation <b>{ activeNode?.key }</b></span>,
    requiresWriteAccess: true,
    onClick: async () => {
      const [id, graph] = splitUid(activeNode.wvrId || activeNode.id)
      const promise = new Promise((resolve, reject) =>
        dispatch(setGraphRenameRelationProps({
          id,
          graph,
          key: activeNode.key,
          promise: {
            resolve,
            reject
          }
        }))
      )

      try {
        const { key } = await promise
        const from = visToWvrMap[activeNode.from]
        const to = visToWvrMap[activeNode.to]
        const results = await createRelationInGraph(key, getUid(from), getUid(to))
        dispatch(setQueryResults(results))
        await Weaver.Node.getFromGraph(id, graph).destroy()
        props.removeGraphEdge(activeNode.id)
        setActiveNode(undefined)
        setGraphRenameRelationProps(undefined)
      } catch(err) {
        console.error(err)
      }
    },
    hidden: () => (active?.type !== RELATION) || (activeNode?.id.includes('->')) || (activeSelection) || (graphData.abstract)
  }, {
    key: 'reverse-relation',
    title: () => <span>Reverse relation <b>{ activeNode?.key }</b></span>,
    requiresWriteAccess: true,
    onClick: async () => {
      const [id, graph] = splitUid(activeNode.wvrId || activeNode.id)
      const toId = removeVisPrefix(activeNode.to)
      const fromId = removeVisPrefix(activeNode.from)
      const results = await createRelationInGraph(`${activeNode.key}`, toId, fromId)
      dispatch(setQueryResults(results))
      await Weaver.Node.getFromGraph(id, graph).destroy()
      props.removeGraphEdge(activeNode.id)
      setActiveNode(undefined)
    },
    hidden: () => (active?.type !== RELATION) || (activeNode?.id.includes('->')) || (activeSelection) || (graphData.abstract)
  }, {
    key: 'expand-all-of-type',
    title: () => <span>Expand all nodes of type <b>{ activeNode?.type?.label }</b></span>,
    onClick: async () => {
      const { nodes } = graphData
      const typeId = activeNode.type.id
      nodesToExpand = _.filter(nodes, ({ id, group }) => (group === typeId) && (id !== typeId))
      props.updateGraphNodes(await expandNodes(_.map(nodesToExpand, 'id')).graphData)
    },
    hidden: active?.type !== NODE || !activeNode?.type
  }, {
    key: 'invert-selection',
    title: 'Invert selection',
    onClick: () => {
      const { nodes } = graphData
      const invertedNodeSelection = _.without(_.keys(nodes), ...active.network.getSelectedNodes())
      active.network.setSelection({ nodes: invertedNodeSelection }, { highlightEdges: false })
    },
    hidden: active?.type !== NODE || (!activeNode && !activeSelection)
  }, {
    key: 'search-for-merge-request',
    requiresWriteAccess: false,
    title: 'Search for Merge Request',
    onClick: async () => {
      const { nodes } = graphData
      const visId = active.nodes[0]
      const commitId = await Weaver.getInstance().getCoreManager().gitBlame(nodes[visId].wvrId)
      const mergedNodes = await MergeRequest.getMerged()
      const mrNode = mergedNodes.find((configNode) => configNode.get('commitId') === commitId)
      mrNode
      ?
        history.push(`${props.currentProject}/merge-requests/${enc(mrNode?.id())}`)
      :
        Modal.info({
          icon: null,
          width: '60%',
          title: <span>No associated merge request found</span>,
          closable: true
        })
    },
    hidden: (active?.nodes?.length != 1) && (active?.type !== NODE || graphData.abstract)
  }, {
    key: 'destroy-node',
    title: () => activeNode ? <span>Destroy <b>{activeNode?.label}</b></span> : <span>Destroy <b>{_.size(activeSelection)} nodes</b></span>,
    danger: true,
    requiresWriteAccess: true,
    requiresConfirmation: true,
    confirmationTitle: () => activeNode ? <span>Are you sure you want to destroy <b>{activeNode?.label}</b></span> : <span>Are you sure you want to destroy <b>{_.size(activeSelection)} nodes</b></span>,
    onClick: async () => {
      const { nodes } = graphData

      const nodesToDestroy = activeNode ? [activeNode] : activeSelection
      const activeSelectionIds = _.map(nodesToDestroy, 'id')
      const destroyedIds = activeSelectionIds
      for (const id of activeSelectionIds) {
        const relatedItems = jsonPath.query(nodes, `$..[?(@.from=="${id}" || @.to=="${id}")].id`)
        destroyedIds.push(...relatedItems)
      }

      await Weaver.Node.batchDestroy(
        _.map(nodesToDestroy, ({ wvrId }) => {
          const [id, graph] = splitUid(wvrId)
          return Weaver.Node.getFromGraph(id, graph)
        })
      )

      const nodesToUpdate = _.filter(nodes, (node) =>
        destroyedIds.includes(node.group)
      ).reduce((acc, node) => {
        acc[node.id] = {
          ...node,
          group: 'undefined'
        }
        return acc
      }, {})

      if (currentItem.type === ATTRIBUTES && destroyedIds.includes(currentItem.id)) {
        props.setTabDisabled({ key: 'attributes', disabled: true })
        params.set('tab', 'home')
        history.replace({ pathname: url, search: params.toString(), hash })
        setTab('home')
      }

      setActive(undefined)
      setActiveNode(undefined)
      setActiveSelection(undefined)
      props.updateGraphNodes({ nodes: nodesToUpdate })
      props.removeGraphNodes(destroyedIds)
    },
    hidden: active?.type !== NODE || graphData.abstract
  }, {
    key: 'destroy-relation',
    danger: true,
    requiresConfirmation: true,
    confirmationTitle: () => activeNode ? <span>Are you sure you want to destroy relation <b>{ activeNode?.key }</b></span> : <span>Are you sure you want to destroy <b>{_.size(activeSelection)} relations</b></span>,
    requiresWriteAccess: true,
    title: () => {
      return activeNode ? <span>Destroy relation <b>{ activeNode?.key }</b></span> : <span>Destroy <b>{_.size(activeSelection)} relations</b></span>
    },
    onClick: async () => {
      const { nodes, edges } = graphData
      const relsToDestroy = activeNode ? [activeNode] : activeSelection
      const destroyedIds = _.map(relsToDestroy, 'id')

      const destroyedEdges = _.map(destroyedIds, (id) => edges[id])

      let nodesToUpdate = {}

      await Weaver.Node.batchDestroy(
        _.map(relsToDestroy, ({ wvrId }) => {
          const [id, graph] = splitUid(wvrId)
          return Weaver.RelationNode.getFromGraph(id, graph)
        })
      )

      await Promise.map(destroyedEdges, async (edge) => {
        if (getMemberKeys().includes(edge.key)) {
          const members = await new Weaver.Query()
                                          .hasRelationOut(edge.key, Weaver.Node.get(edge.to))
                                          .find()

          if (!members.length > 0) {
            nodesToUpdate[edge.to] = {
              ...nodes[edge.to],
              group: 'undefined'
            }
          }

          const newTypes = _.flatten(await Promise.map(getMemberKeys(), (memberKey) =>
            new Weaver.Query()
              .hasRelationIn(memberKey, Weaver.Node.get(edge.from))
              .find()
          ))

          nodesToUpdate[edge.from] = {
            ...nodes[edge.from],
            group: newTypes.length > 0 ? newTypes[0].id() : 'undefined'
          }
        }
      })

      setActive(undefined)
      setActiveNode(undefined)
      props.removeGraphEdges(destroyedIds)
      props.updateGraphNodes({ nodes: nodesToUpdate })
    },
    hidden: (active?.type !== RELATION) || (activeNode?.id.includes('->')) || (graphData.abstract)
  }, {
    key: 'save-graph-as-view',
    title: 'Save as view',
    onClick: () => {
      const nodesOnScreen = Object.values(graphCtx.richNodesMap)
      const filtered = nodesOnScreen.filter(n => !(n instanceof Weaver.RelationNode || n instanceof Weaver.AttributeNode))
      const param = "restrict ".concat(
        filtered
          .map(n => n.id())
          .filter((id) => id.indexOf('@') === -1)
          .map((id) => `'${ id }'`).join(' ')
      ) + "\nselectOut '*'"
      history.push(`${props.currentProject}/settings/views/new?viewType=graphView&query=${ param }`)
    },
    hidden: _.keys(graphData.nodes).length < 1 || active,
    requiresWriteAccess: true
  }, {
    key: 'save-graph-as-image',
    title: 'Save as image',
    onClick: () => {
      const canvas = document.getElementById("graph-container").children[0].children[0]
      const tmpLink = document.createElement('a')
      tmpLink.download = 'graph.png'
      tmpLink.href = canvas.toDataURL('image/png')
      document.body.appendChild(tmpLink)
      tmpLink.click()
      document.body.removeChild(tmpLink)
    },
    hidden: _.isEmpty(graphData.nodes) || active
  }]

  return (
    <ContextMenu actions={actions}>
      { children }
    </ContextMenu>
  )
}

export default connect(({ graph, graphFilter, projects, explore }) => ({
  currentItem: explore.currentItem,
  currentProject: projects.currentProject,
  macros: explore.macros,
  nodeView: graph.nodeView,
  filteredNodes: [
    ...graphFilter.filteredNodes.byGraph,
    ...graphFilter.filteredNodes.byOther,
    ...graphFilter.filteredNodes.byRelation,
    ...graphFilter.filteredNodes.byOther,
    ...graphFilter.filteredNodes.byType,
  ]
})
, ({
  removeGraphEdge,
  removeGraphEdges,
  removeGraphNode,
  removeGraphNodes,
  setCreatingNode,
  setEditingNode,
  setCurrentItem,
  setFilteredNodesByOther,
  setTabDisabled,
  setTab,
  updateGraphNodes,
  updateGraphGroups,
  updateTypeFilter,
  updateTypeFilters
}))(GraphContextMenu)
